// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Title bar ───────────────────────────────────────────────── */

/* ── Content area ────────────────────────────────────────────── */
mat-dialog-content {
  min-width: 600px;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
  overflow-x: hidden;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

/* ── Footer ──────────────────────────────────────────────────── */
mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.button-gap {
  gap: 12px;
}

/* ── Report results card ─────────────────────────────────────── */
.results-card {
  background: #f8f9fa;
  border: 1px solid #dbdcdd;
  border-radius: 4px;
  padding: 16px;
  margin-top: 4px;
}

/* ── Report header ───────────────────────────────────────────── */
.report-title {
  color: #0b2d71;
  font-size: 1.1rem;
}

/* ── Hierarchy tree ──────────────────────────────────────────── */
.bu-name {
  font-size: 14px;
  margin-bottom: 2px;
}

.level-1 { padding-left: 1.5rem;  font-size: 14px; padding-bottom: 2px; }
.level-2 { padding-left: 3rem;    font-size: 14px; padding-bottom: 2px; color: #444; }
.level-3 { padding-left: 5rem;    font-size: 14px; padding-bottom: 2px; color: #444; }
.level-4 { padding-left: 7rem;    font-size: 14px; padding-bottom: 2px; color: #444; }

/* ── Count values in navy ────────────────────────────────────── */
.count {
  color: #0b2d71;
  font-weight: 600;
}

.btn::after { content: '' !important; display: none !important; }

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/tools/bu-redesign-metrics/bu-redesign-metrics.component.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE,mEAAmE;AACnE;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA,mEAAmE;AACnE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,WAAW,oBAAoB,GAAG,eAAe,EAAE,mBAAmB,EAAE;AACxE,WAAW,kBAAkB,KAAK,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE;AACrF,WAAW,kBAAkB,KAAK,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE;AACrF,WAAW,kBAAkB,KAAK,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE;;AAErF,mEAAmE;AACnE;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc,sBAAsB,EAAE,wBAAwB,EAAE","sourcesContent":["/* ── Title bar ───────────────────────────────────────────────── */\n\n/* ── Content area ────────────────────────────────────────────── */\nmat-dialog-content {\n  min-width: 600px;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n  overflow-x: hidden;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\n/* ── Footer ──────────────────────────────────────────────────── */\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n/* ── Report results card ─────────────────────────────────────── */\n.results-card {\n  background: #f8f9fa;\n  border: 1px solid #dbdcdd;\n  border-radius: 4px;\n  padding: 16px;\n  margin-top: 4px;\n}\n\n/* ── Report header ───────────────────────────────────────────── */\n.report-title {\n  color: #0b2d71;\n  font-size: 1.1rem;\n}\n\n/* ── Hierarchy tree ──────────────────────────────────────────── */\n.bu-name {\n  font-size: 14px;\n  margin-bottom: 2px;\n}\n\n.level-1 { padding-left: 1.5rem;  font-size: 14px; padding-bottom: 2px; }\n.level-2 { padding-left: 3rem;    font-size: 14px; padding-bottom: 2px; color: #444; }\n.level-3 { padding-left: 5rem;    font-size: 14px; padding-bottom: 2px; color: #444; }\n.level-4 { padding-left: 7rem;    font-size: 14px; padding-bottom: 2px; color: #444; }\n\n/* ── Count values in navy ────────────────────────────────────── */\n.count {\n  color: #0b2d71;\n  font-weight: 600;\n}\n\n.btn::after { content: '' !important; display: none !important; }\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
